export default "__VITE_ASSET__Bu11bLq3__"